import { TableContentWithoutEdit } from '../../Common/Table/tableContent';
import React, { useEffect, useState, Fragment, useRef } from "react";

export default class ComponentToPrint extends React.Component {
    render() {

        const data = this.props.data;
        const rowNames = this.props.rowNames;
        const searchData = this.props.searchData;
        const grnNumbers = this.props.grnNUmbers;
        return (
            <div>
                <h3><center><u>Goods Receive Note Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                {grnNumbers.map((x, index) => {
                    return (
                        <div key={index} className="row">
                            <div className="row alternative_cls">
                                <div className="col width1 "><p><b><p />GRN Number </b><br /><br /> {x}</p> </div>
                                <div className="col width2"><p><b><p />WeighPoint Name </b><br /><br /> {data[x] !== undefined ? data[x][0].collectionPointName : "0"}</p> </div>
                                <div className="col width3"><p><b><p />Received Estate </b><br /><br />{data[x] !== undefined ? data[x][0].transferedEstate : "0"}</p> </div>
                                <div className="col width3"><p><b><p />Received Division </b><br /><br /> {data[x] !== undefined ? data[x][0].transferedDivision : "0"}</p> </div>
                                <div className="col width2"><p><b><p />Transfer Note</b><br /><br /> {data[x] !== undefined ? data[x][0].transferNote : "0"}</p></div>
                                <div className="col pb-2 width4">
                                    <table
                                        id={x}
                                        className="display dataTable no-footer">

                                        <thead>
                                            <tr>
                                                <th>Field</th>
                                                <th>Total Amount<br/>(Kg)</th>
                                                <th>Deduction<br />(Kg)</th>
                                                <th>Net Amount<br />(Kg)</th>
                                                <th>Bag<br/>Count</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <TableContentWithoutEdit
                                                data={data[x]}
                                                contentRowNames={rowNames}
                                                hasEdit={false}
                                            />
                                        </tbody>
                                    </table>
                                </div>
                                <hr />
                            </div>
                        </div>
                    )
                })}
            </div>
        );
    }
}